var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('base-panel',{attrs:{"asset":_vm.asset,"tabs":_vm.tabs,"asset-module":_vm.assetModule,"hide-print-button":false,"last-update":_vm.lastUpdate,"hide-tabs":_vm.hideTabs,"notifications":_vm.notifications}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }